export default class CacheItem {
  private _key: string;
  private _value: any;
  private _expirerSeconds: number;
  private _createdTime: Date;

  constructor(key: string, value: any, expirerSeconds = 60) {
    this._key = key;
    this._value = value;
    this._expirerSeconds = expirerSeconds;
    this._createdTime = new Date();
  }

  get key() {
    return this._key;
  }

  set key(value: string) {
    this._key = value;
  }

  get value() {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
  }

  get expirerSeconds() {
    return this._expirerSeconds;
  }

  set expirerSeconds(value: number) {
    this._expirerSeconds = value;
  }

  /** 判断是否过期 */
  isExpirered() {
    const diff = ((new Date()).getTime() - this._createdTime.getTime()) / 1000;
    return diff > this._expirerSeconds;
  }
}
